// import $ from 'jquery';
import './Components/_Anchor.js';
import './Components/_Matchheight.js';
import './Components/_Modal.js';
import './Components/_Header.js';
import './Components/_Slider.js';

window.onload = function () {
  let player = document.getElementById('mv1-video');
  if (player) {
    player.play();
  }
};
